<template>
  <div class="login-container container-fluid p-0 m-0 justify-content-center d-flex flex-column align-items-center">
    <div class="row w-100">
      <div class="col-xl-4 offset-xl-4 col-xl-4 offset-xl-4">
        <div class="cotizarlo-general-wrapper admin">
          <div class="card-body px-5 py-5">
            <form>
              <div class="row">
                <div class="col-8 offset-2 text-center">
                  <img src="@/assets/images/app_logo/cotizarlo_white.svg" class="img-fluid" />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12 text-center">
                  <strong class="text-white">Reestablece tu contraseña:</strong>
                </div>
              </div>
              <div class="mt-4 mb-3" v-if="!successSendEmail">
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <div class="input-icon-container">
                        <input type="email" placeholder="Usuario / e-mail" :class="{ 'is-invalid': $v.email.$error }" id="email" v-model="email" autocomplete="new_email"/>
                        <i class="fa fa-user icon" aria-hidden="true"></i>
                      </div>
                      <small class="form-text text-danger mt-1" v-show="!$v.email.email">Ingresa un email válido.</small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <button type="submit" class="btn form-control btn-save" @click.prevent="recoverPassword">
                      Enviar correo de recuperación
                    </button>
                  </div>
                </div>  
              </div>
              <div v-if="successSendEmail" class="row my-4">
                <div class="col-12 ">
                  <div class="d-flex align-items-center">
                    <span class="icon-cot-correcto text-white" style="font-size: 2em;"></span>
                    <p class="text-mail-sended mb-0 ml-3 text-left text-white">
                      ¡Correo enviado! Revisa tu bandeja y sigue las instrucciones para restablecer tu contraseña
                    </p>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col text-center">
                  <router-link :to="{name:'loginAdmin'}" tag="a">
                    <small class="text-muted" style="font-weight:700; color:#BFBFBF;">¡Ya me acordé! Login</small>
                  </router-link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>
<script>
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],
  data() {
    return {
      email: null,
      successSendEmail:false
    };
  },
  validations: {
    email: { email, required },
  },
  methods:{
    recoverPassword(){
      if (this.$v.$invalid) {
        alert("Error en campos")
      }else{
        this.$store.dispatch('client/recoverPassword',{
          email:this.email,
        }).then(
          () => {
            this.successSendEmail = true
          }
        );
        
      }
    }
  }
};
</script>